module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.card) ? _c('div', [_c('ul', {
    staticClass: "demo-list-three mdl-list"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.card.records), function(record) {
    return _c('li', {
      staticClass: "mdl-list__item mdl-list__item--three-line",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.goToEdit(record)
        }
      }
    }, [_c('span', {
      staticClass: "mdl-list__item-primary-content"
    }, [_c('span', [_vm._v(_vm._s(record.product.name))]), _vm._v(" "), _c('span', {
      staticClass: "mdl-list__item-text-body"
    }, [_c('span', {
      staticClass: "row"
    }, [_c('span', {
      staticClass: "half"
    }, [(record.product.variety) ? [_vm._v("\n                        " + _vm._s(record.product.variety) + ",\n                      ")] : _vm._e(), _vm._v("\n                      " + _vm._s(record.product.origin) + ",\n                      " + _vm._s(record.product.unit) + "\n                    ")], 2), _vm._v(" "), _c('span', {
      staticClass: "half"
    }, [_c('span', {
      staticClass: "row"
    }, [_c('span', {
      staticClass: "half"
    }, _vm._l((record.publicPrices), function(price) {
      return _c('span', {
        staticStyle: {
          "display": "block"
        }
      }, [_vm._v("\n                              " + _vm._s(_vm._f("currency")(price.price)) + "\n                          ")])
    })), _vm._v(" "), _c('span', {
      staticClass: "half"
    }, _vm._l((record.draftPrices), function(price) {
      return _c('span', {
        staticStyle: {
          "color": "red",
          "display": "block"
        }
      }, [_vm._v("\n                              " + _vm._s(_vm._f("currency")(price.price)) + "\n                          ")])
    }))])])])])]), _vm._v(" "), _vm._m(1, true)])
  })], 2)]) : _c('my-spinner')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "mdl-list__item mdl-list__item--three-line"
  }, [_c('span', {
    staticClass: "mdl-list__item-primary-content"
  }, [_c('span', [_vm._v("Produkt")]), _vm._v(" "), _c('span', {
    staticClass: "mdl-list__item-text-body"
  }, [_c('span', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "half"
  }, [_vm._v("\n                       \n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "half"
  }, [_c('span', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "half"
  }, [_vm._v("\n                          Na stronie\n                        ")]), _vm._v(" "), _c('span', {
    staticClass: "half"
  }, [_vm._v("\n                          Wprowadzone\n                        ")])])])])])]), _vm._v(" "), _c('span', {
    staticClass: "mdl-list__item-secondary-content"
  }, [_c('span', {
    staticClass: "mdl-list__item-secondary-action"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("edit")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "mdl-list__item-secondary-content"
  }, [_c('span', {
    staticClass: "mdl-list__item-secondary-action"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("edit")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9d04708a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RecordsList.vue
// module id = 268
// module chunks = 1